import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[scrollToFixDirective]',
  exportAs: 'scrollToFixDirective',
})

export class scrollToFixDirective implements OnInit {
  @Input() id_attr;

  constructor(private el: ElementRef) {

  }
  ngOnInit(): void {
    if (this.id_attr) {
      document.getElementById(this.id_attr).onscroll = (event => {
        console.log(this.el.nativeElement.offsetTop);
        console.log(event);
      })
    }

  }

}
